/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { addDataLayer } from 'shared/utils/utils';
import { NavigationBarHOC } from 'shared/hoc/navigation/NavigationBarHOC';
import { facebook, instagram, linkedIn, twitterX } from 'shared/assets/icons';

import './Footer.scss';

/**
 * defines footer when needed is made
 * 
 * @param props
 * 
 * @returns html to render footer message if available after login
 * 
**/

const footerMiddleMenus = [
    { id: 7, label: 'Sell with Us', type: 'link',  type: 'external-link', redirectTo: '', openUrl: "https://www.caringtransitions.com/two-ways-to-sell", active: false },
    // { label: 'Become our Caring Partner', type: 'link', redirectTo: '', active: false },
    { id: 8, label: 'Know more about Caring Transitions', type: 'link',  type: 'external-link', redirectTo: '', openUrl: "https://www.caringtransitions.com/", active: false },
];

export const FooterNew = (props) => {
    const footerTopMenus = [
        { id: 1, label: 'News and Stories', type: 'link', redirectTo:  '/stories', active: false },
        { id: 2, label: 'Locations', type: 'link', redirectTo: '/locations', active: false },
        { id: 3, label: 'Our Story', type: 'link', redirectTo: '/ourstory', active: false },
        { id: 4, label: 'FAQ', type: 'link', redirectTo: '/help/faq', active: false },
        { id: 5, label: 'Terms & Conditions', type: 'external-link', redirectTo: '', openUrl: "https://assets.ctbids.com/buyer/CTBidsTermsandConditions1.10.25.pdf", active: false },
        { id: 6, label: 'Privacy Policy', type: 'external-link', redirectTo: '', openUrl: props?.privacyPolicy?.pdfUrl, active: false  },
    ];


    const openInNewTab = (link) => {
        window.open(link, '_blank');

        let dataLayerData = {
            'event': 'scmlink_clicks',
            'title': link
        }
        addDataLayer(dataLayerData); 
    }

    return (
        <div className='footer-box'>
            <div className='footer-top-box'>
                <div className='logo-box'>
                    <img onClick={()=> props.history.push('/')} src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="CTBids home logo" className="logo-image clickable" />
                </div>
                
                <NavigationBarHOC props={props} menus={footerTopMenus} menuStyling={{fontWeight: 'normal', backgroundColor: 'transparent'}} />
                
                <div className='social-media-box'>
                    <div className='social-media' onClick={() => { openInNewTab('https://www.facebook.com/CTBidsOnlineAuctions/'); }}>{facebook}</div>
                    <div className='social-media' onClick={() => { openInNewTab('https://www.instagram.com/ctbids/'); }}>{instagram}</div>
                    <div className='social-media' onClick={() => { openInNewTab('https://www.linkedin.com/company/ctbids'); }}>{linkedIn}</div>
                    <div className='social-media' onClick={() => { openInNewTab('https://x.com/CTBids_'); }}>{twitterX}</div>
                </div>
            </div>
            <div className='footer-middle-box'>
                <NavigationBarHOC props={props} menus={footerMiddleMenus} menuStyling={{fontWeight: 'normal', color: "#ffffff", backgroundColor: 'transparent'}} />
            </div>
            <div className='footer-bottom-box'>
                <div className='text-center copy-right'>Copyright © 2025 C.T. Franchising Systems, Inc. dba Caring Transitions. All Rights Reserved. No part of this web page may be reproduced in any way, or by any means, without the prior written permission of C.T. Franchising Systems, Inc.</div>
                <div>Each Caring Transitions ® location is independently owned and operated.</div>
            </div>
        </div>
    )
};